import React from 'react'
import Layout from './Layout'
import { mobileAssets } from 'src/containers/PreCache'
import RegisterForm from './RegisterForm'
import { Link } from 'react-router-dom'

export default function RegisterMobile() {
  return (
    <Layout>
      <div>
        <Link to="/">
          <img src={mobileAssets.landingBgMobile} alt="Background" style={{ width: '100%', height: 'auto' }} />
        </Link>
      </div>
      <div className="content-wrapper">
        <RegisterForm />
        {/* <p className='closedText'>Registration is now closed.</p>
        <p className='closedText'>Thank you for your interest and participation!</p> */}
      </div>
    </Layout>
  )
}
